import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, throwError } from 'rxjs';
import { LoadingService } from '../loading.service';
import { NavigationService } from '../navigation.service';
import { NotificationService } from '../notification.service';
import { environment } from '../../../../environments/environment';
import { ExtraHeader } from '../../models/auth.model';
import { TranslatePipe } from '../translate.pipe';
@Injectable({
  providedIn: 'root'
})
export class ApiHandlerService {

  httpHeadersWeb: HttpHeaders = new HttpHeaders({
    Platform: `${environment.platform_header}`
  });

  constructor(
    private httpClient: HttpClient,
    private spinnerService: LoadingService,
    private navigationService: NavigationService,
    private notificationService : NotificationService,
    private translatePipe: TranslatePipe
  ) { }

  doGetBlob(endpoint: string, showLoader = true, hideLoader = true): Observable<Blob> {
    return this.httpClient.get(environment.apiHost+endpoint, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/pdf'
      })
    });
  }

  doGet<T>(url: string, show_notification: boolean,show_loader: boolean,query_params?: any, headers?: ExtraHeader[]): Observable<T>{
    if (show_loader) {
      this.spinnerService.show();
    }
    if(headers){
      headers.forEach((obj)=>{
        this.httpHeadersWeb = this.httpHeadersWeb.set(obj.key,obj.value);
      });
    }
    return this.httpClient.get<T>(environment.apiHost+url,{
      headers: this.httpHeadersWeb,
      params: query_params?query_params:undefined
    }).pipe(
      map((data: T) => {
        if (show_loader) {
          this.spinnerService.hide();
        }
        return data as T;
      }),
       catchError(this.handleError.bind(this))
    );
  }

  doPost<T>(url: string, parameters:unknown, show_notification: boolean,  show_loader: boolean, headers?: ExtraHeader[]): Observable<T> {
    if (show_loader) {
      this.spinnerService.show();
    }

    if(headers){
      headers.forEach((obj)=>{
        this.httpHeadersWeb = this.httpHeadersWeb.set(obj.key,obj.value);
      });
    }
    return this.httpClient.post<T>(environment.apiHost+url, parameters,{ headers: this.httpHeadersWeb }).pipe(
      map((data: T) => {
        if (show_loader) {
            this.spinnerService.hide();
        }
        return data as T;
      }),
       catchError(this.handleError.bind(this))
    );
  }

  doPut<T>(url: string, parameters: unknown, show_notification: boolean,  show_loader: boolean, headers?: ExtraHeader[]): Observable<T> {
    if (show_loader) {
      this.spinnerService.show();
    }
    if(headers){
      headers.forEach((obj)=>{
        this.httpHeadersWeb = this.httpHeadersWeb.set(obj.key,obj.value);
      });
    }
    return this.httpClient.put<T>(environment.apiHost+url, parameters,{ headers: this.httpHeadersWeb }).pipe(
      map((data: T) => {
        if (show_loader) {
          this.spinnerService.hide();
        }

          return data as T;
      }),
      catchError(this.handleError.bind(this))
    );
  }
  doDelete<T>(url: string, show_notification: boolean,show_loader: boolean,query_params?: any, headers?: ExtraHeader[]): Observable<T>{
    if (show_loader) {
      this.spinnerService.show();
    }
    if(headers){
      headers.forEach((obj)=>{
        this.httpHeadersWeb = this.httpHeadersWeb.set(obj.key,obj.value);
      });
    }

    return this.httpClient.delete<T>(environment.apiHost+url,{
      headers: this.httpHeadersWeb,
      params: query_params?query_params:undefined
    }).pipe(
      map((data: T) => {
        if (show_loader) {
          this.spinnerService.hide();
        }
        return data as T;
      }),
       catchError(this.handleError.bind(this))
    );
  }
  handleError(error: HttpErrorResponse) {
    console.log(error)
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      // console.error(`Backend returned code ${error.status}, body was: `, error.error);
    }

    if (error?.error?.code === 50001 && error.error?.error==='INTERNAL_SERVER_ERROR') {
      this.notificationService.show(error?.error?.reason ,'error');
    }
    this.spinnerService.hide();
    let msg = error && error.message ? error.message : 'Something bad happened; please try again later.';
    if(error && error.error && error.error.message && !(error?.error?.code === 50001 && error.error?.error==='INTERNAL_SERVER_ERROR')){
      msg = error.error.message;
      // this.notificationService.show(msg,'error');
       this.notificationService.show(error.error.error ? this.translatePipe.transform(error.error.error) : msg,'error');
    }

    if (error && error.status && error.status == 401) {
      this.navigationService.navigateTo('/');
      // this.notificationService.showNotification('danger',msg);
    }

    // Return an observable with a user-facing error message.
    return throwError(() => JSON.stringify(error.error));
  }

//   doPutForOtherPurpose<T>(url: string, parameters: unknown | any, show_notification: boolean, show_loader: boolean, headers?: ExtraHeader[]): Observable<any> {
//     if (show_loader) {
//         this.spinnerService.show();
//     }

//     return new Promise ((resolve,reject) => {
//       try {
//         fetch(url,{
//           method:'PUT',
//           body:parameters
//         }).then(res => {
//           if(res.status === 200 && res.ok === true) {

//           }
//         })
//         resolve(true);
//       } catch (error) {
//         reject(error)
//       }
//     })

//     return this.httpClient.put<T>(url, parameters).pipe(
//         map((data: T) => {
//             if (show_loader) {
//                 this.spinnerService.hide();
//             }
//             return data as T;
//         }),
//         catchError(this.handleError.bind(this))
//     );
// }

  async doPutForOtherPurpose( url: string, parameters: any, show_notification: boolean, show_loader: boolean, headers?: ExtraHeader[]) {
    if (show_loader) {
      this.spinnerService.show();
    }

    const fetchOptions: RequestInit = {
      method: 'PUT',
      body: parameters
    };


    return await fetch(url, fetchOptions).then(async (res) => {
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      if(res.ok === true && res.status === 200) {
        this.spinnerService.hide();
        return true
      } else {
        return false;
      }
    });
  }


    doGetUrl<T>(url: string, show_notification: boolean,show_loader: boolean,query_params?: any): Observable<T>{
    if (show_loader) {
      this.spinnerService.show();
    }
   
    return this.httpClient.get<T>(url,{
      headers: this.httpHeadersWeb,
      params: query_params?query_params:undefined
    }).pipe(
      map((data: T) => {
        if (show_loader) {
          this.spinnerService.hide();
        }
        return data as T;
      }),
       catchError(this.handleError.bind(this))
    );
  }
}
